import {
  LOGIN_SUCCESS,
  REFRESH_TOKEN_FAILURE,
  LOGOUT,
  REGISTER_USER_SUCCESS,
  SEND_EXTERNAL_AUTH_TOKEN_SUCCESS,
  CREATE_PARTIAL_USER_SUCCESS,
} from './index';

export const USER_LOGGED_IN = [
  LOGIN_SUCCESS,
  REGISTER_USER_SUCCESS,
  SEND_EXTERNAL_AUTH_TOKEN_SUCCESS,
];

export const TOKEN_IS_AVAILABLE = [
  ...USER_LOGGED_IN,
  CREATE_PARTIAL_USER_SUCCESS,
];

export const USER_LOGGED_OUT = [LOGOUT, REFRESH_TOKEN_FAILURE];



// WEBPACK FOOTER //
// ./src/actionTypes/actionBundles.js